import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentFeatureMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentFeatureMediaFragment.generated'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiTeacher_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  description?: string | null
  descriptionFormat?: string | null
  language?: string | null
  primaryLanguage?: string | null
  path?: string | null
  seoTitle?: string | null
  seoDescription?: string | null
  title?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiTags?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiTeacher_ContentFragmentFragmentDoc = gql`
  fragment YITeacher_ContentFragment on Content {
    id
    contentId
    contentType
    published
    publishedAtDate
    shortDescription
    shortDescriptionFormat
    description
    descriptionFormat
    language
    primaryLanguage
    path
    seoTitle
    seoDescription
    title
    ...ContentFeatureMediaFragment
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiTags: contentReferencesFrom(types: "yi-tag") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentFeatureMediaFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
